import Cookies from 'js-cookie';

import {
  COOKIE_KEY_CHANNEL_ID,
  COOKIE_KEY_CHAT_COMPANY_ID,
  COOKIE_KEY_CHAT_YN,
  COOKIE_KEY_SCENARIO_ID,
  COOKIE_KEY_SCENARIO_YN,
  COOKIE_KEY_TEL_NO,
  COOKIE_KEY_USER_ID,
} from '../const/AppConst';

// 상담 세션 쿠키 접근 지점.
// 회사 쿠키는 모든 화면 분기의 기준이라 읽기·쓰기를 한 곳으로 모은다.

// 다른 상담 쿠키와 동일한 수명
const EXPIRES = { expires: 1 };

export const getChatCompanyId = () => Cookies.get(COOKIE_KEY_CHAT_COMPANY_ID);

// 서버 응답의 companyId 는 숫자, 화면 분기는 문자열 비교 — String 정규화 필수
export const setChatCompanyId = (companyId) =>
  Cookies.set(COOKIE_KEY_CHAT_COMPANY_ID, String(companyId), EXPIRES);

// 상담 시작 시 세팅하는 시나리오 쿠키. /init 과 /init2 가 공유한다.
// 시나리오 사용 여부는 두 진입점 모두 항상 'Y' — 정책이 바뀌면 여기만 고친다.
// (TestView 는 SCENARIO_YN='N' 경로가 따로 있어 이 함수를 쓰지 않는다)
export const startConsultSession = ({ telNo, sid, chatYn }) => {
  Cookies.set(COOKIE_KEY_TEL_NO, telNo);
  Cookies.set(COOKIE_KEY_SCENARIO_YN, 'Y');
  Cookies.set(COOKIE_KEY_SCENARIO_ID, sid);
  if (chatYn !== undefined) Cookies.set(COOKIE_KEY_CHAT_YN, chatYn);
};

export const setChannelId = (channelId) =>
  Cookies.set(COOKIE_KEY_CHANNEL_ID, channelId);

// 새 상담 진입 전 이전 세션 흔적 제거.
// 회사 쿠키가 남으면 다른 회사 전용 화면이 뜨므로 반드시 포함한다
export const clearConsultSession = () => {
  [
    COOKIE_KEY_CHANNEL_ID,
    COOKIE_KEY_USER_ID,
    COOKIE_KEY_TEL_NO,
    COOKIE_KEY_SCENARIO_YN,
    COOKIE_KEY_SCENARIO_ID,
    COOKIE_KEY_CHAT_YN,
    COOKIE_KEY_CHAT_COMPANY_ID,
  ].forEach((key) => Cookies.remove(key));
};
